import { Avatar, HStack, StackProps, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useBgHover, useBorderColor } from "../../themes/colors";

interface Props extends StackProps {
  src: string | null | undefined;
  prefix: string | undefined;
  name: string | undefined;
  slug: string | undefined;
  onClose: () => void;
}

export const PickResellerCard = ({
  src,
  prefix,
  name,
  slug,
  onClose,
  ...rest
}: Props) => {
  const navigate = useNavigate();
  const borderColor = useBorderColor();
  const bgHover = useBgHover();

  const handleClick = () => {
    navigate(`/product/${prefix}/${slug}`);
    onClose();
  };

  return (
    <HStack
      borderWidth={"1px"}
      borderColor={borderColor}
      rounded={"lg"}
      flex={"1"}
      py={2}
      px={3.5}
      align={"center"}
      cursor={"pointer"}
      onClick={handleClick}
      _hover={{ bg: bgHover }}
      {...rest}
    >
      <Avatar
        src={src ? `${process.env.REACT_APP_MEDIA_URL}${src}` : ""}
        name={name || ""}
        size={["xs", "sm", "md"]}
        color={"#FFFFFF"}
      />
      <Text noOfLines={2} textStyle={"b-reg"}>
        {name}
      </Text>
    </HStack>
  );
};
